/**
 * @author Muhammad Omran
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2020-10-21
 * @description Implementation of the GraphQL query to retrieve a featured list.
 * @filename featured-list-query.ts
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL query to retrieve list of type Fixed or Dynamic List.
 *
 * @type {GraphQLTaggedNode}
 */
export const FEATURED_LIST_QUERY: GraphQLTaggedNode = graphql`
  query featuredListQuery($id: ID!) {
    list(id: $id) {
      errors {
        created
        id
        location
        type
      }
      hasErrors
      list {
        __typename
        ... on DynamicList {
          description
          id
          label
          name
          previews {
            edges {
              preview {
                mediaAsset {
                  id
                  files {
                    name
                    path
                  }
                  topLevelMediaType {
                    kind
                  }
                }
                link
                kind
              }
            }
          }
          subTitle
          title
        }
        ... on FixedList {
          description
          id
          landingPageUrl
          badges {
            imageLink
            link
            previews {
              count
              edges {
                cursor
                preview {
                  link
                  kind
                  mediaAsset {
                    files {
                      name
                      path
                    }
                    topLevelMediaType {
                      kind
                    }
                  }
                }
              }
            }
          }
          label
          name
          previews {
            edges {
              preview {
                link
                kind
                mediaAsset {
                  id
                  files {
                    name
                    path
                  }
                  topLevelMediaType {
                    kind
                  }
                }
              }
            }
          }
          subTitle
          title
          revision
        }
      }
    }
  }
`;
